<template>
<div>
 组态组件123123
</div>
</template>

<script>
export default {
  name: "Configuration"
}
</script>

<style scoped>

</style>
